import React, { useState, useRef, useLayoutEffect } from 'react';
import { Text, Group, UnstyledButton, Collapse } from '@mantine/core';
import { IconChevronDown, IconMessage } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

// Комментарий учителя в истории уроков. Влезает в одну строку — показываем как есть,
// длиннее — прячем под заголовок, по клику текст выезжает вниз (как панель отметки урока у учителя).
function LessonComment({ comment }) {
  const { t } = useTranslation();
  const measureRef = useRef(null);
  const [isLong, setIsLong] = useState(comment.includes('\n'));
  const [expanded, setExpanded] = useState(false);

  // Невидимая копия текста в одну строку: если она шире блока — комментарий длинный.
  // Следим за шириной, чтобы на повороте экрана решение пересчитывалось.
  useLayoutEffect(() => {
    const el = measureRef.current;
    if (!el) return undefined;
    const check = () => setIsLong(comment.includes('\n') || el.scrollWidth > el.clientWidth);
    check();
    const observer = new ResizeObserver(check);
    observer.observe(el);
    return () => observer.disconnect();
  }, [comment]);

  return (
    <div className="lesson-comment">
      <Text size="sm" ref={measureRef} className="lesson-comment-measure" aria-hidden>
        {comment}
      </Text>
      {isLong ? (
        <>
          <UnstyledButton
            className="lesson-comment-header"
            onClick={() => setExpanded((value) => !value)}
            aria-expanded={expanded}
          >
            <Group justify="space-between" wrap="nowrap" gap="sm">
              <Group gap={6} wrap="nowrap">
                <IconMessage size={18} color="#0EA5E9" style={{ flexShrink: 0 }} />
                <Text size="sm" fw={600}>{t('lessonFeedback')}</Text>
              </Group>
              <IconChevronDown size={18} className={`lesson-comment-chevron ${expanded ? 'open' : ''}`} />
            </Group>
          </UnstyledButton>
          <Collapse expanded={expanded}>
            <Text size="sm" pt={8} style={{ whiteSpace: 'pre-line' }}>
              {comment}
            </Text>
          </Collapse>
        </>
      ) : (
        <Group gap={6} wrap="nowrap">
          <IconMessage size={18} color="#0EA5E9" style={{ flexShrink: 0 }} />
          <Text size="sm">{comment}</Text>
        </Group>
      )}
    </div>
  );
}

export default LessonComment;
